import createValues from './createValues';
import plain from './structure/plain';

export default createValues(plain);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/values.js
// module id = 1599
// module chunks = 0